import { render, staticRenderFns } from "./PromptProfileDlg.vue?vue&type=template&id=651d8b0c"
import script from "./PromptProfileDlg.vue?vue&type=script&lang=js"
export * from "./PromptProfileDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports